import { createSelector } from 'reselect';

import {
  getPaginationV2Params,
  getStatusParams,
  getBarSelectionParams,
} from './../../../api-adapter';
import { FILTER_TYPE_PARAM_NAME, TESTS_PAGE_STATUSES, TIME_INTERVAL_OPTIONS } from '../../../constants';
import { eventMetaDataSelector } from '../tracking/selectors';
import { TRACKING_SUB_AREA } from '../../../trackingV2';
import { getTestListStatsConfig } from '../../../util';

const userStore = (store) => store.user;
export const routerLocation = (store) => store.router.location;

export const createTestListPagination = (testListStore) => createSelector([
  testListStore,
], (testList) => {
  const current = testList.getIn(['pagination', 'current']);
  const size = testList.getIn(['pagination', 'size']);
  const total = testList.get('totalTestCases');

  return {
    current,
    totalPages: Math.ceil(total / size),
    show: total > size,
    size,
  };
});

export const createTestCasesParamsSelector = (getFiltersParams, testListStore) => createSelector([
  getFiltersParams,
  testListStore,
  userStore,
  (store, options) => options,
], (filtersParams, testList, user, options = {}) => {
  const { status } = options;
  return {
    ...filtersParams,
    ...getPaginationV2Params(testList.get('pagination')),
    ...(getStatusParams(status)),
    ...(getBarSelectionParams(testList.get('trends'))),
    sort: testList.getIn(['sort', 'direction']),
    sort_by: testList.getIn(['sort', 'field']),
    org_id: user.get('organization').id,
  };
});

export const createTestCasesTrendsParamsSelector = (
  testCasesParamsSelector, testListStore,
) => createSelector([
  testCasesParamsSelector,
  testListStore,
], (testCasesParams, testList) => {
  const key = testList.getIn(['trends', 'interval']);

  return {
    ...testCasesParams,
    groupby: TIME_INTERVAL_OPTIONS[key].value,
  };
});

export const createTestListSelector = ({
  testListStore,
  testListPagination,
  getFiltersAsQueryObject,
  type,
  productSubArea = TRACKING_SUB_AREA.TEST_OVERVIEW_TESTS_LIST,
}) => createSelector([
  testListStore,
  testListPagination,
  getFiltersAsQueryObject,
  eventMetaDataSelector,
], (testList, pagination, filtersQuery, eventMetaData) => ({
  pagination,
  isDownloadingCSV: testList.get('isDownloadingCSV'),
  loadingData: testList.get('loadingData'),
  testCases: testList.get('testCases'),
  sort: testList.get('sort'),
  statsConfig: getTestListStatsConfig(
    testList.get('stats').set('total', testList.get('totalTestCases')),
  ),
  filtersQuery,
  eventMetaData: {
    ...eventMetaData,
    sku_type: type,
    product_sub_area: productSubArea,
  },
  trends: testList.get('trends'),
}));

export const createStatusSelector = (statusStoreKey) => createSelector([
  (options) => options,
], (options) => {
  const localStatusKey = window.localStorage.getItem(statusStoreKey);
  const validLocalStatus = Object.keys(TESTS_PAGE_STATUSES).includes(localStatusKey) ?
    localStatusKey : undefined;
  const key = options?.[FILTER_TYPE_PARAM_NAME] || validLocalStatus;
  const { status } = TESTS_PAGE_STATUSES[key] || TESTS_PAGE_STATUSES.all;

  return {
    status,
  };
});
